/* eslint-disable */
export default {
  download: 'Baixar',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
